import { E_SIMPLIFIED_BUYING_BETA } from "api/ApiPath";
import client from "api/client";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { injectable } from "tsyringe";
import { IESimplifiedBuyingRepository } from "../domain/repositories/IESimplifiedBuyingRepository";
import { OrderSimDataHeaderModel } from "./model/OrderSimDataHeaderModel";
import { OrderSimDataRequestModel } from "./model/OrderSimDataRequestModel";
import { OrderSimDataResponseModel } from "./model/OrderSimDataResponseModel";

@injectable()
export class ESimplifiedBuyingImpl implements IESimplifiedBuyingRepository {
  async orderSimData(
    body: OrderSimDataRequestModel,
    headers: OrderSimDataHeaderModel,
  ): Promise<BaseApiResponseModel<OrderSimDataResponseModel>> {
    return await client.post(E_SIMPLIFIED_BUYING_BETA.ORDER_SIM_DATA, body, {
      skipAuthorization: true,
      headers: {
        partnerKey: headers?.partnerKey,
        signature: headers?.signature,
        "Content-Type": "application/json",
      },
    });
  }
}
